import React, { useState, useEffect } from 'react';
import { FiSearch, FiEdit, FiToggleLeft, FiToggleRight, FiEye, FiEyeOff, FiCheck, FiX, FiFileText, FiFile, FiCheckCircle, FiXCircle, FiUsers, FiMapPin, FiCalendar, FiFilter, FiRefreshCw, FiChevronDown, FiChevronUp, FiArrowUp, FiArrowDown, FiMoreVertical, FiSettings, FiShield, FiAward, FiTrendingUp, FiActivity, FiBarChart2, FiPieChart, FiTarget, FiZap, FiClock, FiAlertCircle, FiGlobe, FiPhone, FiMail, FiStar, FiCreditCard, FiPackage, FiShoppingCart, FiDollarSign, FiTrendingDown, FiDownload, FiUpload, FiEdit2, FiTrash2, FiEye2, FiPlus, FiMinus, FiChevronRight, FiChevronLeft, FiHome, FiTruck, FiNavigation, FiUser } from 'react-icons/fi';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import { FaRupeeSign } from "react-icons/fa";

const VendorList = () => {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [approvalFilter, setApprovalFilter] = useState('approved');
  const [roomFacilitiesFilter, setRoomFacilitiesFilter] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalVendors, setTotalVendors] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [ownerExists, setOwnerExists] = useState(false);
  const [showOwnerForm, setShowOwnerForm] = useState(false);
  const [ownerData, setOwnerData] = useState({
    name: '',
    password: '',
    contactNumber: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showDocsModal, setShowDocsModal] = useState(false);
  const [selectedVendorDocs, setSelectedVendorDocs] = useState(null);
  const [showPlanModal, setShowPlanModal] = useState(false);
  const [selectedVendorForPlan, setSelectedVendorForPlan] = useState(null);
  const [availablePlans, setAvailablePlans] = useState([]);
  const [selectedPlanId, setSelectedPlanId] = useState('');
  const [customPrice, setCustomPrice] = useState('');
  const [gstNumber, setGstNumber] = useState('');

  const isPDF = (url) => {
    if (!url) return false;
    return url.toLowerCase().includes('.pdf') || url.toLowerCase().includes('pdf');
  };

  const isWordDoc = (url) => {
    if (!url) return false;
    return url.toLowerCase().includes('.doc') || url.toLowerCase().includes('.docx');
  };

  const isExcelDoc = (url) => {
    if (!url) return false;
    return url.toLowerCase().includes('.xls') || url.toLowerCase().includes('.xlsx');
  };

  const isTextDoc = (url) => {
    if (!url) return false;
    return url.toLowerCase().includes('.txt');
  };

  const isDocument = (url) => {
    return isPDF(url) || isWordDoc(url) || isExcelDoc(url) || isTextDoc(url);
  };

  const getDocumentIcon = (url) => {
    if (isPDF(url)) return { icon: '📄', label: 'PDF Document', color: '#dc3545' };
    if (isWordDoc(url)) return { icon: '📝', label: 'Word Document', color: '#2b579a' };
    if (isExcelDoc(url)) return { icon: '📊', label: 'Excel Document', color: '#217346' };
    if (isTextDoc(url)) return { icon: '📃', label: 'Text Document', color: '#6c757d' };
    return { icon: '📎', label: 'Document', color: '#6c757d' };
  };

  const openInNewTab = (url) => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  const approveDocuments = async (vendorId) => {
    try {
      const response = await api.post(`/superadmin/vendors/${vendorId}/approve-documents`);
      if (response.data.success) {
        toast.success('Documents approved successfully');
        setShowDocsModal(false);
        fetchVendors();
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to approve documents');
    }
  };

  const unapproveDocuments = async (vendorId) => {
    try {
      const response = await api.post(`/superadmin/vendors/${vendorId}/unapprove-documents`);
      if (response.data.success) {
        toast.success('Document approval revoked successfully');
        setShowDocsModal(false);
        fetchVendors();
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to revoke approval');
    }
  };

  useEffect(() => {
    fetchVendors();
    fetchPlans();
  }, [statusFilter, approvalFilter, roomFacilitiesFilter, search, currentPage,itemsPerPage]);

  const fetchVendors = async (isManualRefresh = false) => {
    try {
      const params = {
        page: currentPage,
        limit: itemsPerPage
      };
      if (statusFilter !== 'all') params.status = statusFilter;
      if (approvalFilter !== 'all') params.approvalStatus = approvalFilter;
      if (roomFacilitiesFilter !== 'all') params.roomFacilities = roomFacilitiesFilter;
      if (search) params.search = search;

      if (isManualRefresh) {
        setRefreshing(true);
        toast.loading('Refreshing vendors...', { id: 'refresh' });
      }

      console.log('Fetching vendors with params:', params);
      const response = await api.get('/superadmin/vendors', { params });
      console.log('Vendors response:', response.data);
      
      if (response.data.success) {
        setVendors(response.data.data);
        setTotalPages(response.data.totalPages || 1);
        setTotalVendors(response.data.total || 0);
        
        // Show success message for manual refresh
        if (isManualRefresh) {
          toast.success(`Refreshed! Found ${response.data.data.length} vendors`, { id: 'refresh' });
        }
      } else {
        toast.error('Failed to load vendors data', { id: 'refresh' });
      }
    } catch (error) {
      console.error('Fetch vendors error:', error);
      toast.error(`Failed to fetch vendors: ${error.response?.data?.message || error.message}`, { id: 'refresh' });
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  const fetchPlans = async () => {
    try {
      const response = await api.get('/superadmin/subscription-plans');
      if (response.data.success) {
        setAvailablePlans(response.data.data);
      }
    } catch (error) {
      console.error('Failed to fetch plans');
    }
  };

  const openPlanModal = (vendor) => {
    setSelectedVendorForPlan(vendor);
    setSelectedPlanId(vendor.subscription?.plan?._id || '');
    setCustomPrice('');
    setGstNumber(vendor.restaurantDetails?.gstNumber?.toUpperCase() || '');
    setShowPlanModal(true);
  };

  const assignPlan = async () => {
    if (!selectedPlanId) {
      toast.error('Please select a plan');
      return;
    }

    try {
      const selectedPlan = availablePlans.find(p => p._id === selectedPlanId);
      const payload = {
        vendorId: selectedVendorForPlan._id,
        planId: selectedPlanId
      };

      // Add customPrice only if it's provided
      if (customPrice && customPrice.trim() !== '') {
        payload.customPrice = parseFloat(customPrice);
      }

      // Add GST number if provided
      if (gstNumber && gstNumber.trim() !== '') {
        payload.gstNumber = gstNumber;
      }

      const response = await api.post(`/superadmin/vendors/${selectedVendorForPlan._id}/assign-plan`, payload);
      if (response.data.success) {
        toast.success('Plan assigned successfully');
        setShowPlanModal(false);
        setCustomPrice(''); // Reset custom price
        setGstNumber(''); // Reset GST number
        fetchVendors();
      }
    } catch (error) {
      toast.error('Failed to assign plan');
    }
  };

  const toggleVendorStatus = async (vendorId) => {
    try {
      const response = await api.patch(`/superadmin/vendors/${vendorId}/toggle-status`);
      if (response.data.success) {
        toast.success(response.data.message);
        fetchVendors();
      }
    } catch (error) {
      toast.error('Failed to update vendor status');
    }
  };

  const toggleService = async (vendorId, serviceType, enabled) => {
    try {
      const serviceMap = {
        homeDelivery: 'homeDeliveryEnabled',
        pickup: 'pickupEnabled',
        vehicle: 'vehicleEnabled',
        roomService: 'roomServiceEnabled'
      };
      
      const response = await api.put(`/superadmin/vendors/${vendorId}/service-settings`, {
        [serviceMap[serviceType]]: enabled
      });
      
      if (response.data.success) {
        toast.success(`${serviceType === 'homeDelivery' ? 'Home Delivery' : serviceType === 'pickup' ? 'Pickup' : serviceType === 'vehicle' ? 'Vehicle' : 'Room Service'} service ${enabled ? 'enabled' : 'disabled'} successfully`);
        
        // Update the selected vendor in state
        setSelectedVendor(prev => ({
          ...prev,
          settings: {
            ...prev.settings,
            [serviceMap[serviceType]]: enabled
          }
        }));
        
        // Refresh vendors list
        fetchVendors();
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to update service');
    }
  };

  const viewVendorDetails = async (vendor) => {
    setSelectedVendor(vendor);
    setShowModal(true);
    setOwnerData({ name: vendor.personalDetails.name, password: '', contactNumber: vendor.personalDetails.contactNumber });
    
    // Check if owner exists for this email (for both pending and rejected vendors)
    if (vendor.approvalStatus === 'pending' || vendor.approvalStatus === 'rejected') {
      try {
        const response = await api.get('/superadmin/vendors/check-owner', {
          params: { email: vendor.personalDetails.email }
        });
        setOwnerExists(response.data.ownerExists);
      } catch (error) {
        console.error('Failed to check owner:', error);
        setOwnerExists(false);
      }
    }
  };

  const viewVendorDocuments = (vendor) => {
    setSelectedVendorDocs(vendor);
    setShowDocsModal(true);
  };

  const approveVendor = async (vendorId) => {
    try {
      const response = await api.post(`/superadmin/vendors/${vendorId}/approve`);
      if (response.data.success) {
        toast.success('Vendor approved successfully');
        setShowModal(false);
        setShowOwnerForm(false);
        fetchVendors();
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to approve vendor');
    }
  };

  const createOwner = async (vendorId) => {
    if (!ownerData.name || !ownerData.password || !ownerData.contactNumber) {
      toast.error('Please fill all owner details');
      return;
    }

    try {
      const response = await api.post(`/superadmin/vendors/${vendorId}/create-owner`, ownerData);
      if (response.data.success) {
        toast.success('Owner created and vendor approved successfully!');
        setShowOwnerForm(false);
        setOwnerData({ name: '', password: '', contactNumber: '' });
        setShowModal(false);
        fetchVendors();
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to create owner');
    }
  };

  const rejectVendor = async (vendorId) => {
    const reason = prompt('Enter rejection reason:');
    if (!reason) return;

    try {
      const response = await api.post(`/superadmin/vendors/${vendorId}/reject`, { reason });
      if (response.data.success) {
        toast.success('Vendor rejected');
        setShowModal(false);
        fetchVendors();
      }
    } catch (error) {
      toast.error('Failed to reject vendor');
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 flex items-center justify-center">
        <div className="text-center">
          <div className="relative inline-flex items-center justify-center">
            <div className="w-20 h-20 border-4 border-indigo-200 rounded-full"></div>
            <div className="w-20 h-20 border-4 border-indigo-600 rounded-full animate-spin absolute border-t-transparent"></div>
          </div>
          <p className="mt-4 text-gray-600 font-medium">Loading Vendors...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 flex items-center gap-3">
                <div className="w-10 h-10 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl flex items-center justify-center">
                  <FiUsers className="text-white text-xl" />
                </div>
                Vendor Management
              </h1>
              <p className="text-gray-600 mt-1">Manage all restaurant vendors and their approval status</p>
            </div>
            
            <div className="flex items-center gap-3">
              <button
                onClick={() => fetchVendors(true)}
                disabled={refreshing}
                className="flex items-center gap-2 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
              >
                <FiRefreshCw className={`text-sm ${refreshing ? 'animate-spin' : ''}`} />
                <span className="text-sm font-medium">{refreshing ? 'Refreshing...' : 'Refresh'}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Filters Section */}
        <div className="bg-white rounded-xl shadow-md border border-gray-100 p-6 mb-8">
          <div className="flex flex-col lg:flex-row lg:items-center gap-4">
            {/* Search */}
            <div className="flex-1 min-w-[250px] relative">
              <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="Search by name, email, or phone..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>
            
            {/* Approval Filter */}
            <select 
              value={approvalFilter}
              onChange={(e) => setApprovalFilter(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white"
            >
              <option value="all">All Status</option>
              <option value="approved">Approved</option>
              <option value="rejected">Rejected</option>
            </select>

            {/* Status Filter */}
            <select 
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white"
            >
              <option value="all">All Activity</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>

            {/* Room Facilities Filter */}
            <select 
              value={roomFacilitiesFilter}
              onChange={(e) => setRoomFacilitiesFilter(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white"
            >
              <option value="all">All Vendors</option>
              <option value="with">With Room Facilities</option>
              <option value="without">Without Room Facilities</option>
            </select>
          </div>
        </div>

        {/* Vendors Table */}
        <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Restaurant Name</th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Owner Details</th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Credentials</th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Location</th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Subscription Plan</th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Approval Status</th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Active Status</th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {vendors.map(vendor => (
                  <tr key={vendor._id} className="hover:bg-gray-50 transition-colors duration-150">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center">
                          <FiMapPin className="text-indigo-600 text-sm" />
                        </div>
                        <span className="font-semibold text-gray-900">{vendor.restaurantDetails.restaurantName}</span>
                      </div>
                    </td>
                    
                    <td className="px-6 py-4">
                      <div className="space-y-2">
                        <div className="flex items-center gap-2">
                          <span className="text-xs font-medium text-gray-500">Name:</span>
                          <span className="text-sm text-gray-900">{vendor.personalDetails.name}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="text-xs font-medium text-gray-500">Email:</span>
                          <span className="text-sm text-gray-900">{vendor.personalDetails.email}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="text-xs font-medium text-gray-500">Contact:</span>
                          <span className="text-sm text-gray-900">{vendor.personalDetails.contactNumber}</span>
                        </div>
                      </div>
                    </td>

                    <td className="px-6 py-4">
                      <div className="space-y-2">
                        <div className="flex items-center gap-2">
                          <span className="text-xs font-medium text-gray-500">Username:</span>
                          <span className="text-sm font-mono text-blue-600">{vendor.ownerCredentials.username}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="text-xs font-medium text-gray-500">Password:</span>
                          <span className="text-sm font-mono text-green-600">{vendor.ownerCredentials.plainTextPassword || 'N/A'}</span>
                        </div>
                      </div>
                    </td>

                    <td className="px-6 py-4">
                      <div className="space-y-2">
                        <div className="flex items-center gap-2">
                          <span className="text-xs font-medium text-gray-500">City:</span>
                          <span className="text-sm font-mono text-blue-500">{vendor.restaurantDetails.city}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="text-xs font-medium text-gray-500">Lat:</span>
                          <span className="text-sm font-mono text-blue-600">
                            {vendor.restaurantDetails.location?.coordinates[1]?.toFixed(6) || 'N/A'}
                          </span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="text-xs font-medium text-gray-500">Lng:</span>
                          <span className="text-sm font-mono text-green-600">
                            {vendor.restaurantDetails.location?.coordinates[0]?.toFixed(6) || 'N/A'}
                          </span>
                        </div>
                      </div>
                    </td>

                    <td className="px-6 py-4">
                      {vendor.subscription?.plan ? (
                        <div className="bg-gray-50 border border-gray-200 rounded-lg p-3">
                          <div className="font-semibold text-gray-700">{vendor.subscription.plan.name}</div>
                          <div className="text-sm text-gray-600">₹{vendor.subscription.plan.price}</div>
                          {vendor.subscription.endDate && (
                            <div className={`text-xs font-semibold mt-1 ${
                              (() => {
                                const endDate = new Date(vendor.subscription.endDate);
                                const today = new Date();
                                const daysUntilExpiry = Math.ceil((endDate - today) / (1000 * 60 * 60 * 24));
                                
                                if (daysUntilExpiry < 0) return 'text-red-600'; // Expired - red
                                if (daysUntilExpiry <= 3) return 'text-red-600'; // Expiring within 3 days - red
                                return 'text-green-600'; // Active - green
                              })()
                            }`}>
                              {(() => {
                                const endDate = new Date(vendor.subscription.endDate);
                                const today = new Date();
                                const daysUntilExpiry = Math.ceil((endDate - today) / (1000 * 60 * 60 * 24));
                                
                                if (daysUntilExpiry < 0) return 'Expired';
                                return `Expires on ${endDate.toLocaleDateString('en-GB', {
                                  day: 'numeric',
                                  month: 'short',
                                  year: 'numeric',
                                })}`;
                              })()}
                            </div>
                          )}
                        </div>
                      ) : (
                        <span className="text-gray-400 text-sm">No plan</span>
                      )}
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                        vendor.approvalStatus === 'approved' ? 'bg-green-100 text-green-700' : 
                        vendor.approvalStatus === 'pending' ? 'bg-amber-100 text-amber-700' : 
                        'bg-red-100 text-red-700'
                      }`}>
                        {vendor.approvalStatus.charAt(0).toUpperCase() + vendor.approvalStatus.slice(1)}
                      </span>
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                        vendor.isActive ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
                      }`}>
                        {vendor.isActive ? 'Active' : 'Inactive'}
                      </span>
                    </td>

                    <td className="px-6 py-4">
                      <div className="flex flex-col gap-2">
                        <button 
                          onClick={() => viewVendorDetails(vendor)}
                          className="px-3 py-1 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors duration-200 text-sm font-medium"
                          title="View Details"
                        >
                          View
                        </button>

                        <button 
                          onClick={() => viewVendorDocuments(vendor)}
                          className="px-3 py-1 bg-indigo-500 text-white rounded-lg hover:bg-indigo-600 transition-colors duration-200 text-sm font-medium"
                          title="View Documents"
                        >
                          Documents
                        </button>

                        <button 
                          onClick={() => openPlanModal(vendor)}
                          className="px-3 py-1 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors duration-200 text-sm font-medium"
                          title="Assign Plan"
                        >
                          Assign Plan
                        </button>

                        {vendor.approvalStatus === 'approved' && (
                          <button 
                            onClick={() => toggleVendorStatus(vendor._id)}
                            className={`px-3 py-1 rounded-lg transition-colors duration-200 text-sm font-medium ${
                              vendor.isActive ? 'bg-amber-500 hover:bg-amber-600 text-white' : 'bg-green-500 hover:bg-green-600 text-white'
                            }`}
                            title={vendor.isActive ? 'Deactivate' : 'Activate'}
                          >
                            {vendor.isActive ? 'Deactivate' : 'Activate'}
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {vendors.length === 0 && (
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <FiUsers className="text-gray-400 text-2xl" />
              </div>
              <p className="text-gray-500 font-medium">No vendors found</p>
              <p className="text-gray-400 text-sm mt-1">Try adjusting your search or filters</p>
            </div>
          )}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="bg-white rounded-xl shadow-md border border-gray-100 p-6 mt-6">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
              {/* Left info */}
              <div className="text-sm text-gray-600">
                Showing {vendors.length} of {totalVendors} vendors
              </div>

              {/* Pagination buttons */}
              <div className="flex items-center gap-2">
                <button
                  onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                  disabled={currentPage === 1}
                  className="px-3 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 text-sm font-medium"
                >
                  <FiChevronLeft className="w-4 h-4" />
                  Previous
                </button>

                {[...Array(totalPages)].map((_, idx) => {
                  const pageNum = idx + 1;
                  if (
                    pageNum === 1 ||
                    pageNum === totalPages ||
                    (pageNum >= currentPage - 1 && pageNum <= currentPage + 1)
                  ) {
                    return (
                      <button
                        key={pageNum}
                        onClick={() => setCurrentPage(pageNum)}
                        className={`w-9 h-9 rounded-lg font-medium transition-colors duration-200 text-sm ${
                          pageNum === currentPage
                            ? 'bg-indigo-600 text-white'
                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                        }`}
                      >
                        {pageNum}
                      </button>
                    );
                  } else if (
                    pageNum === currentPage - 2 ||
                    pageNum === currentPage + 2
                  ) {
                    return (
                      <span key={pageNum} className="px-2 text-gray-400">
                        ...
                      </span>
                    );
                  }
                  return null;
                })}

                <button
                  onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                  disabled={currentPage === totalPages}
                  className="px-3 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 text-sm font-medium"
                >
                  Next
                  <FiChevronRight className="w-4 h-4" />
                </button>
              </div>

              {/* Items per page selector */}
              <div className="flex items-center gap-2 text-sm">
                <span className="text-gray-600">Show</span>
                <select
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(Number(e.target.value));
                    setCurrentPage(1); // reset page
                  }}
                  className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
                <span className="text-gray-600">per page</span>
              </div>
            </div>
          </div>
        )}

      </div>

      {/* Vendor Details Modal */}
      {showModal && selectedVendor && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-white border-b border-gray-200 p-6 rounded-t-2xl">
              <div className="flex items-center justify-between">
                <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
                  <FiUsers className="text-indigo-600" />
                  Vendor Details
                </h2>
                <button 
                  onClick={() => setShowModal(false)}
                  className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors duration-200"
                >
                  <FiX className="text-gray-600" />
                </button>
              </div>
            </div>
            
            <div className="p-6 space-y-8">
              {/* Personal Details */}
              <div className="bg-gray-50 rounded-xl p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                  <FiUser className="text-indigo-600" />
                  Personal Details
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-white p-4 rounded-lg border border-gray-200">
                    <label className="text-xs font-medium text-gray-500 block mb-1">Owner Name:</label>
                    <span className="text-gray-900 font-medium">{selectedVendor.personalDetails.name}</span>
                  </div>
                  <div className="bg-white p-4 rounded-lg border border-gray-200">
                    <label className="text-xs font-medium text-gray-500 block mb-1">Email:</label>
                    <span className="text-gray-900 font-medium">{selectedVendor.personalDetails.email}</span>
                  </div>
                  <div className="bg-white p-4 rounded-lg border border-gray-200">
                    <label className="text-xs font-medium text-gray-500 block mb-1">Username:</label>
                    <span className="text-gray-900 font-medium">{selectedVendor.ownerCredentials.username}</span>
                  </div>
                  <div className="bg-white p-4 rounded-lg border border-gray-200">
                    <label className="text-xs font-medium text-gray-500 block mb-1">Contact:</label>
                    <span className="text-gray-900 font-medium">{selectedVendor.personalDetails.contactNumber}</span>
                  </div>
                  {selectedVendor.personalDetails.identityCard && (
                    <div className="bg-white p-4 rounded-lg border border-gray-200">
                      <label className="text-xs font-medium text-gray-500 block mb-1">Identity Card:</label>
                      <span className="text-gray-900 font-medium">{selectedVendor.personalDetails.identityCard}</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Restaurant Details */}
              <div className="bg-gray-50 rounded-xl p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                  <FiMapPin className="text-indigo-600" />
                  Restaurant Details
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-white p-4 rounded-lg border border-gray-200">
                    <label className="text-xs font-medium text-gray-500 block mb-1">Restaurant Name:</label>
                    <span className="text-gray-900 font-medium">{selectedVendor.restaurantDetails.restaurantName}</span>
                  </div>
                  <div className="bg-white p-4 rounded-lg border border-gray-200">
                    <label className="text-xs font-medium text-gray-500 block mb-1">Address:</label>
                    <span className="text-gray-900 font-medium">{selectedVendor.restaurantDetails.city}, {selectedVendor.restaurantDetails.address}</span>
                  </div>
                  {selectedVendor.restaurantDetails.fssaiNumber && (
                    <div className="bg-white p-4 rounded-lg border border-gray-200">
                      <label className="text-xs font-medium text-gray-500 block mb-1">FSSAI Number:</label>
                      <span className="text-gray-900 font-medium">{selectedVendor.restaurantDetails.fssaiNumber}</span>
                    </div>
                  )}
                  {selectedVendor.restaurantDetails.gstNumber && (
                    <div className="bg-white p-4 rounded-lg border border-gray-200">
                      <label className="text-xs font-medium text-gray-500 block mb-1">GST Number:</label>
                      <span className="text-gray-900 font-medium">{selectedVendor.restaurantDetails.gstNumber}</span>
                    </div>
                  )}
                  {selectedVendor.restaurantDetails.location && (
                    <div className="bg-white p-4 rounded-lg border border-gray-200">
                      <label className="text-xs font-medium text-gray-500 block mb-1">Location:</label>
                      <span className="text-gray-900 font-medium">
                        Lat: {selectedVendor.restaurantDetails.location.coordinates[1]}, 
                        Long: {selectedVendor.restaurantDetails.location.coordinates[0]}
                      </span>
                    </div>
                  )}
                  <div className="bg-white p-4 rounded-lg border border-gray-200">
                    <label className="text-xs font-medium text-gray-500 block mb-1">Registered On:</label>
                    <span className="text-gray-900 font-medium">{new Date(selectedVendor.createdAt).toLocaleDateString()}</span>
                  </div>
                </div>
              </div>

              {/* Owner Credentials */}
              {/* <div className="detail-section">
                <h3>Owner Credentials</h3>
                <div className="detail-grid">
                  <div className="detail-item">
                    <label>Username:</label>
                    <span>{selectedVendor.ownerCredentials.username}</span>
                  </div>
                </div>
              </div> */}

              {/* Status */}
              <div className="detail-section">
                <h3>Status</h3>
                <div className="detail-grid">
                  <div className="detail-item">
                    <label>Approval Status:</label>
                    <span className={`badge ${
                      selectedVendor.approvalStatus === 'approved' ? 'badge-success' : 
                      selectedVendor.approvalStatus === 'pending' ? 'badge-warning' : 
                      'badge-danger'
                    }`}>
                      {selectedVendor.approvalStatus.charAt(0).toUpperCase() + selectedVendor.approvalStatus.slice(1)}
                    </span>
                  </div>
                  <div className="detail-item">
                    <label>Active Status:</label>
                    <span className={`badge ${selectedVendor.isActive ? 'badge-success' : 'badge-danger'}`}>
                      {selectedVendor.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                  
                </div>
              </div>

              {/* Service Settings */}
              {selectedVendor.approvalStatus === 'approved' && (
                <div className="detail-section">
                  <h3>Service Settings</h3>
                  <div className="detail-grid">
                    <div className="detail-item" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <div>
                        <label style={{ marginBottom: '4px', display: 'block' }}>Home Delivery:</label>
                        <span className={`badge ${selectedVendor.settings?.homeDeliveryEnabled ? 'badge-success' : 'badge-danger'}`}>
                          {selectedVendor.settings?.homeDeliveryEnabled ? 'Enabled' : 'Disabled'}
                          
                        </span>
                        <button
                        className={`btn btn-sm ${selectedVendor.settings?.homeDeliveryEnabled ? 'btn-danger' : 'btn-success'}`}
                        onClick={() => toggleService(selectedVendor._id, 'homeDelivery', !selectedVendor.settings?.homeDeliveryEnabled)}
                        style={{ marginLeft: '10px' }}
                      >
                        {selectedVendor.settings?.homeDeliveryEnabled ? 'Disable' : 'Enable'}
                      </button>
                        
                      </div>
                      
                    </div>
                    
                    <div className="detail-item" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <div>
                        <label style={{ marginBottom: '4px', display: 'block' }}>Pickup Service:</label>
                        <span className={`badge ${selectedVendor.settings?.pickupEnabled ? 'badge-success' : 'badge-danger'}`}>
                          {selectedVendor.settings?.pickupEnabled ? 'Enabled' : 'Disabled'}
                        </span>
                        <button
                        className={`btn btn-sm ${selectedVendor.settings?.pickupEnabled ? 'btn-danger' : 'btn-success'}`}
                        onClick={() => toggleService(selectedVendor._id, 'pickup', !selectedVendor.settings?.pickupEnabled)}
                        style={{ marginLeft: '10px' }}
                      >
                        {selectedVendor.settings?.pickupEnabled ? 'Disable' : 'Enable'}
                      </button>
                      </div>
                      
                    </div>
                    
                    <div className="detail-item" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <div>
                        <label style={{ marginBottom: '4px', display: 'block' }}>Vehicle Service:</label>
                        <span className={`badge ${selectedVendor.settings?.vehicleEnabled ? 'badge-success' : 'badge-danger'}`}>
                          {selectedVendor.settings?.vehicleEnabled ? 'Enabled' : 'Disabled'}
                        </span>
                        <button
                          className={`btn btn-sm ${selectedVendor.settings?.vehicleEnabled ? 'btn-danger' : 'btn-success'}`}
                          onClick={() => toggleService(selectedVendor._id, 'vehicle', !selectedVendor.settings?.vehicleEnabled)}
                          style={{ marginLeft: '10px' }}
                        >
                          {selectedVendor.settings?.vehicleEnabled ? 'Disable' : 'Enable'}
                        </button>
                      </div>
                      
                    </div>
                    
                    <div className="detail-item" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <div>
                        <label style={{ marginBottom: '4px', display: 'block' }}>Room Service:</label>
                        <span className={`badge ${selectedVendor.settings?.roomServiceEnabled ? 'badge-success' : 'badge-danger'}`}>
                          {selectedVendor.settings?.roomServiceEnabled ? 'Enabled' : 'Disabled'}
                        </span>
                        <button
                          className={`btn btn-sm ${selectedVendor.settings?.roomServiceEnabled ? 'btn-danger' : 'btn-success'}`}
                          onClick={() => toggleService(selectedVendor._id, 'roomService', !selectedVendor.settings?.roomServiceEnabled)}
                          style={{ marginLeft: '10px' }}
                        >
                          {selectedVendor.settings?.roomServiceEnabled ? 'Disable' : 'Enable'}
                        </button>
                      </div>
                      
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Owner Creation Form */}
            {(selectedVendor.approvalStatus === 'pending' || selectedVendor.approvalStatus === 'rejected') && !ownerExists && showOwnerForm && (
              <div className="detail-section" style={{ backgroundColor: '#fff3cd', padding: '20px', borderRadius: '8px', marginTop: '20px' }}>
                <h3 style={{ color: '#856404' }}>Create Vendor Owner</h3>
                <p style={{ fontSize: '14px', color: '#856404', marginBottom: '15px' }}>
                  {selectedVendor.approvalStatus === 'rejected' 
                    ? `This vendor was previously rejected. No owner exists for email `
                    : `This is the first vendor with email `}
                  <strong>{selectedVendor.personalDetails.email}</strong>. 
                  Please create an owner account to manage all vendors under this email.
                </p>
                <div className="detail-grid">
                  <div className="detail-item">
                    <label>Owner Name *</label>
                    <input
                      type="text"
                      className="form-control"
                      value={ownerData.name}
                      onChange={(e) => setOwnerData({...ownerData, name: e.target.value})}
                      placeholder="Enter owner name"
                      style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '4px', width: '100%' }}
                    />
                  </div>
                  <div className="detail-item">
                    <label>Contact Number *</label>
                    <input
                      type="text"
                      className="form-control"
                      value={ownerData.contactNumber}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, '');
                        if (value.length <= 10) {
                          setOwnerData({...ownerData, contactNumber: value});
                        }
                      }}
                      placeholder="10-digit number"
                      pattern="[0-9]{10}"
                      maxLength="10"
                      style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '4px', width: '100%' }}
                    />
                  </div>
                  <div className="detail-item">
                    <label>Password *</label>
                    <div className="password-input-wrapper">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        value={ownerData.password}
                        onChange={(e) => setOwnerData({...ownerData, password: e.target.value})}
                        placeholder="Enter password"
                        required
                      />
                      <button
                        type="button"
                        className="password-toggle-btn"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <FiEyeOff /> : <FiEye />}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="modal-footer">
              {selectedVendor.approvalStatus === 'pending' && (
                <>
                  {!ownerExists && !showOwnerForm ? (
                    <button 
                      className="btn btn-warning"
                      onClick={() => setShowOwnerForm(true)}
                    >
                      Create Owner & Approve
                    </button>
                  ) : !ownerExists && showOwnerForm ? (
                    <>
                      <button 
                        className="btn btn-success"
                        onClick={() => createOwner(selectedVendor._id)}
                      >
                        <FiCheck /> Create Owner & Approve
                      </button>
                      <button 
                        className="btn btn-secondary"
                        onClick={() => setShowOwnerForm(false)}
                      >
                        Cancel
                      </button>
                    </>
                  ) : (
                    <button 
                      className="btn btn-success"
                      onClick={() => approveVendor(selectedVendor._id)}
                    >
                      <FiCheck /> Approve (Owner Exists)
                    </button>
                  )}
                  <button 
                    className="btn btn-danger"
                    onClick={() => rejectVendor(selectedVendor._id)}
                  >
                    <FiX /> Reject
                  </button>
                </>
              )}
              {selectedVendor.approvalStatus === 'rejected' && (
                <>
                  {!ownerExists && !showOwnerForm ? (
                    <button 
                      className="btn btn-warning"
                      onClick={() => setShowOwnerForm(true)}
                    >
                      Create Owner & Re-Approve
                    </button>
                  ) : !ownerExists && showOwnerForm ? (
                    <>
                      <button 
                        className="btn btn-success"
                        onClick={() => createOwner(selectedVendor._id)}
                      >
                        <FiCheck /> Create Owner & Re-Approve
                      </button>
                      <button 
                        className="btn btn-secondary"
                        onClick={() => setShowOwnerForm(false)}
                      >
                        Cancel
                      </button>
                    </>
                  ) : (
                    <button 
                      className="btn btn-success"
                      onClick={() => approveVendor(selectedVendor._id)}
                    >
                      <FiCheck /> Re-Approve (Owner Exists)
                    </button>
                  )}
                  <div style={{ padding: '8px 12px', backgroundColor: '#fff3cd', borderRadius: '4px', fontSize: '14px', color: '#856404' }}>
                    This vendor was previously rejected. {ownerExists ? 'Owner exists for this email.' : 'No owner exists - create one first.'}
                  </div>
                </>
              )}
              {selectedVendor.approvalStatus === 'approved' && (
                <>
                  <button 
                    className={`btn ${selectedVendor.isActive ? 'btn-warning' : 'btn-success'}`}
                    onClick={() =>{
                       toggleVendorStatus(selectedVendor._id)
                       setShowModal(false)
                    }}
                  >
                    {selectedVendor.isActive ? <FiToggleRight /> : <FiToggleLeft />}
                    {selectedVendor.isActive ? 'Deactivate' : 'Activate'}
                  </button>
                  <button 
                    className="btn btn-danger"
                    onClick={() => rejectVendor(selectedVendor._id)}
                  >
                    <FiX /> Reject
                  </button>
                </>
              )}
              <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Documents Modal */}
      {showDocsModal && selectedVendorDocs && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-auto" onClick={(e) => e.stopPropagation()}>
            {/* Modal Header */}
            <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white p-6 rounded-t-2xl">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
                    <FiFileText className="text-white text-lg" />
                  </div>
                  <div>
                    <h2 className="text-xl font-bold">Vendor Documents</h2>
                    <p className="text-blue-100 text-sm">{selectedVendorDocs.restaurantDetails.restaurantName}</p>
                  </div>
                </div>
                <button 
                  onClick={() => setShowDocsModal(false)}
                  className="w-8 h-8 bg-white/20 hover:bg-white/30 rounded-lg flex items-center justify-center transition-colors duration-200"
                >
                  <FiX className="text-white text-lg" />
                </button>
              </div>
            </div>
            
            <div className="modal-body">
              <div className="detail-section">
                <h3>Restaurant Documents</h3>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '1.5rem', marginTop: '1rem' }}>
                  {/* FSSAI Certificate */}
                  <div style={{ textAlign: 'center' }}>
                    <h4 style={{ marginBottom: '0.75rem', fontSize: '0.95rem', color: '#333' }}>FSSAI Certificate</h4>
                    {selectedVendorDocs.documents?.fssaiCertificate ? (
                      <div 
                        onClick={() => openInNewTab(selectedVendorDocs.documents.fssaiCertificate)}
                        style={{
                          width: '100%',
                          height: '200px',
                          backgroundImage: isDocument(selectedVendorDocs.documents.fssaiCertificate) 
                            ? 'none' 
                            : `url(${selectedVendorDocs.documents.fssaiCertificate})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          backgroundRepeat: 'no-repeat',
                          borderRadius: '8px',
                          border: '2px solid #e0e0e0',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: isDocument(selectedVendorDocs.documents.fssaiCertificate) ? '#f8f9fa' : 'transparent',
                          transition: 'transform 0.2s, box-shadow 0.2s'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'scale(1.02)';
                          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'scale(1)';
                          e.currentTarget.style.boxShadow = 'none';
                        }}
                      >
                        {isDocument(selectedVendorDocs.documents.fssaiCertificate) && (
                          <div style={{ textAlign: 'center', color: getDocumentIcon(selectedVendorDocs.documents.fssaiCertificate).color }}>
                            <div style={{ fontSize: '4rem', marginBottom: '0.5rem' }}>{getDocumentIcon(selectedVendorDocs.documents.fssaiCertificate).icon}</div>
                            <div style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>{getDocumentIcon(selectedVendorDocs.documents.fssaiCertificate).label}</div>
                            <div style={{ fontSize: '0.75rem', marginTop: '0.25rem', color: '#666' }}>Click to view</div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div style={{ 
                        width: '100%', 
                        height: '200px', 
                        backgroundColor: '#f5f5f5', 
                        borderRadius: '8px', 
                        border: '2px dashed #ccc',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#999'
                      }}>
                        <FiFileText size={40} style={{ marginBottom: '0.5rem' }} />
                        <span>Not Uploaded</span>
                      </div>
                    )}
                  </div>

                  {/* GST Certificate */}
                  <div style={{ textAlign: 'center' }}>
                    <h4 style={{ marginBottom: '0.75rem', fontSize: '0.95rem', color: '#333' }}>GST Certificate</h4>
                    {selectedVendorDocs.documents?.gstCertificate ? (
                      <div 
                        onClick={() => openInNewTab(selectedVendorDocs.documents.gstCertificate)}
                        style={{
                          width: '100%',
                          height: '200px',
                          backgroundImage: isDocument(selectedVendorDocs.documents.gstCertificate) 
                            ? 'none' 
                            : `url(${selectedVendorDocs.documents.gstCertificate})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          backgroundRepeat: 'no-repeat',
                          borderRadius: '8px',
                          border: '2px solid #e0e0e0',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: isDocument(selectedVendorDocs.documents.gstCertificate) ? '#f8f9fa' : 'transparent',
                          transition: 'transform 0.2s, box-shadow 0.2s'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'scale(1.02)';
                          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'scale(1)';
                          e.currentTarget.style.boxShadow = 'none';
                        }}
                      >
                        {isDocument(selectedVendorDocs.documents.gstCertificate) && (
                          <div style={{ textAlign: 'center', color: getDocumentIcon(selectedVendorDocs.documents.gstCertificate).color }}>
                            <div style={{ fontSize: '4rem', marginBottom: '0.5rem' }}>{getDocumentIcon(selectedVendorDocs.documents.gstCertificate).icon}</div>
                            <div style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>{getDocumentIcon(selectedVendorDocs.documents.gstCertificate).label}</div>
                            <div style={{ fontSize: '0.75rem', marginTop: '0.25rem', color: '#666' }}>Click to view</div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div style={{ 
                        width: '100%', 
                        height: '200px', 
                        backgroundColor: '#f5f5f5', 
                        borderRadius: '8px', 
                        border: '2px dashed #ccc',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#999'
                      }}>
                        <FiFileText size={40} style={{ marginBottom: '0.5rem' }} />
                        <span>Not Uploaded</span>
                      </div>
                    )}
                  </div>

                  {/* Trade License */}
                  <div style={{ textAlign: 'center' }}>
                    <h4 style={{ marginBottom: '0.75rem', fontSize: '0.95rem', color: '#333' }}>Trade License</h4>
                    {selectedVendorDocs.documents?.tradeLicense ? (
                      <div 
                        onClick={() => openInNewTab(selectedVendorDocs.documents.tradeLicense)}
                        style={{
                          width: '100%',
                          height: '200px',
                          backgroundImage: isDocument(selectedVendorDocs.documents.tradeLicense) 
                            ? 'none' 
                            : `url(${selectedVendorDocs.documents.tradeLicense})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          backgroundRepeat: 'no-repeat',
                          borderRadius: '8px',
                          border: '2px solid #e0e0e0',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: isDocument(selectedVendorDocs.documents.tradeLicense) ? '#f8f9fa' : 'transparent',
                          transition: 'transform 0.2s, box-shadow 0.2s'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'scale(1.02)';
                          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'scale(1)';
                          e.currentTarget.style.boxShadow = 'none';
                        }}
                      >
                        {isDocument(selectedVendorDocs.documents.tradeLicense) && (
                          <div style={{ textAlign: 'center', color: getDocumentIcon(selectedVendorDocs.documents.tradeLicense).color }}>
                            <div style={{ fontSize: '4rem', marginBottom: '0.5rem' }}>{getDocumentIcon(selectedVendorDocs.documents.tradeLicense).icon}</div>
                            <div style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>{getDocumentIcon(selectedVendorDocs.documents.tradeLicense).label}</div>
                            <div style={{ fontSize: '0.75rem', marginTop: '0.25rem', color: '#666' }}>Click to view</div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div style={{ 
                        width: '100%', 
                        height: '200px', 
                        backgroundColor: '#f5f5f5', 
                        borderRadius: '8px', 
                        border: '2px dashed #ccc',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#999'
                      }}>
                        <FiFileText size={40} style={{ marginBottom: '0.5rem' }} />
                        <span>Not Uploaded</span>
                      </div>
                    )}
                  </div>

                  {/* Restaurant Logo */}
                  <div style={{ textAlign: 'center' }}>
                    <h4 style={{ marginBottom: '0.75rem', fontSize: '0.95rem', color: '#333' }}>Restaurant Logo</h4>
                    {selectedVendorDocs.documents?.restaurantLogo ? (
                      <div 
                        onClick={() => openInNewTab(selectedVendorDocs.documents.restaurantLogo)}
                        style={{
                          width: '100%',
                          height: '200px',
                          backgroundImage: isDocument(selectedVendorDocs.documents.restaurantLogo) 
                            ? 'none' 
                            : `url(${selectedVendorDocs.documents.restaurantLogo})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          backgroundRepeat: 'no-repeat',
                          borderRadius: '8px',
                          border: '2px solid #e0e0e0',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: isDocument(selectedVendorDocs.documents.restaurantLogo) ? '#f8f9fa' : 'transparent',
                          transition: 'transform 0.2s, box-shadow 0.2s'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'scale(1.02)';
                          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'scale(1)';
                          e.currentTarget.style.boxShadow = 'none';
                        }}
                      >
                        {isDocument(selectedVendorDocs.documents.restaurantLogo) && (
                          <div style={{ textAlign: 'center', color: getDocumentIcon(selectedVendorDocs.documents.restaurantLogo).color }}>
                            <div style={{ fontSize: '4rem', marginBottom: '0.5rem' }}>{getDocumentIcon(selectedVendorDocs.documents.restaurantLogo).icon}</div>
                            <div style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>{getDocumentIcon(selectedVendorDocs.documents.restaurantLogo).label}</div>
                            <div style={{ fontSize: '0.75rem', marginTop: '0.25rem', color: '#666' }}>Click to view</div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div style={{ 
                        width: '100%', 
                        height: '200px', 
                        backgroundColor: '#f5f5f5', 
                        borderRadius: '8px', 
                        border: '2px dashed #ccc',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#999'
                      }}>
                        <FiFileText size={40} style={{ marginBottom: '0.5rem' }} />
                        <span>Not Uploaded</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="bg-gray-50 px-6 py-4 rounded-b-2xl flex gap-3 justify-end">
              {selectedVendorDocs.documentsApproved ? (
                <button 
                  onClick={() => unapproveDocuments(selectedVendorDocs._id)}
                  className="px-6 py-2.5 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-lg hover:from-orange-600 hover:to-red-600 transition-all duration-200 font-medium shadow-lg flex items-center gap-2"
                >
                  <FiXCircle />
                  Revoke Approval
                </button>
              ) : (
                <button 
                  onClick={() => approveDocuments(selectedVendorDocs._id)}
                  className="px-6 py-2.5 bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-lg hover:from-green-600 hover:to-emerald-600 transition-all duration-200 font-medium shadow-lg flex items-center gap-2"
                >
                  <FiCheckCircle />
                  Approve Documents
                </button>
              )}
              <button 
                onClick={() => setShowDocsModal(false)}
                className="px-6 py-2.5 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors duration-200 font-medium"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Plan Assignment Modal */}
      {showPlanModal && selectedVendorForPlan && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-[90vh] overflow-auto" onClick={(e) => e.stopPropagation()}>
            {/* Modal Header */}
            <div className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white p-6 rounded-t-2xl">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
                    <FiCreditCard className="text-white text-lg" />
                  </div>
                  <div>
                    <h2 className="text-xl font-bold">Assign Subscription Plan</h2>
                    <p className="text-purple-100 text-sm">Choose a plan for this vendor</p>
                  </div>
                </div>
                <button 
                  onClick={() => setShowPlanModal(false)}
                  className="w-8 h-8 bg-white/20 hover:bg-white/30 rounded-lg flex items-center justify-center transition-colors duration-200"
                >
                  <FiX className="text-white text-lg" />
                </button>
              </div>
            </div>

            {/* Modal Body */}
            <div className="p-6 space-y-6">
              {/* Vendor Info Card */}
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-xl p-4">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center">
                    <FiMapPin className="text-white text-sm" />
                  </div>
                  <h3 className="font-semibold text-gray-800">Vendor Information</h3>
                </div>
                <div className="space-y-1">
                  <p className="text-gray-900 font-medium">{selectedVendorForPlan.restaurantDetails.restaurantName}</p>
                  <p className="text-gray-600 text-sm">Owner: {selectedVendorForPlan.personalDetails.name}</p>
                  <p className="text-gray-600 text-sm">Email: {selectedVendorForPlan.personalDetails.email}</p>
                </div>
              </div>

              {/* Current Plan */}
              {selectedVendorForPlan.subscription?.plan && (
                <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-xl p-4">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-8 h-8 bg-green-500 rounded-lg flex items-center justify-center">
                      <FiAward className="text-white text-sm" />
                    </div>
                    <h3 className="font-semibold text-gray-800">Current Subscription</h3>
                  </div>
                  <div className="space-y-2">
                    <div className="flex items-center justify-between">
                      <span className="text-gray-700 font-medium">{selectedVendorForPlan.subscription.plan.name}</span>
                      <span className="text-green-600 font-bold">₹{selectedVendorForPlan.subscription.plan.price}</span>
                    </div>
                    <div className="flex items-center gap-2 text-sm">
                      <FiCalendar className="text-gray-500" />
                      <span className="text-gray-600">
                        Expires: {new Date(selectedVendorForPlan.subscription.endDate).toLocaleDateString()}
                      </span>
                    </div>
                    <div className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full inline-block">
                      Active Plan
                    </div>
                  </div>
                </div>
              )}

              {/* Plan Selection */}
              <div className="space-y-3">
                <label className="flex items-center gap-2 font-semibold text-gray-800">
                  <FiCreditCard className="text-purple-600" />
                  Select New Plan <span className="text-red-500">*</span>
                </label>
                
                <div className="space-y-2">
                  {availablePlans.length === 0 ? (
                    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 text-center">
                      <FiAlertCircle className="text-yellow-600 text-2xl mx-auto mb-2" />
                      <p className="text-yellow-800">No subscription plans available</p>
                      <p className="text-yellow-600 text-sm">Please contact administrator</p>
                    </div>
                  ) : (
                    <div className="space-y-3">
                      {availablePlans.map(plan => (
                        <label 
                          key={plan._id}
                          className={`block border-2 rounded-xl p-4 cursor-pointer transition-all duration-200 ${
                            selectedPlanId === plan._id 
                              ? 'border-purple-500 bg-purple-50' 
                              : 'border-gray-200 hover:border-gray-300 bg-white'
                          }`}
                        >
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-3">
                              <input
                                type="radio"
                                name="plan"
                                value={plan._id}
                                checked={selectedPlanId === plan._id}
                                onChange={(e) => setSelectedPlanId(e.target.value)}
                                className="w-4 h-4 text-purple-600 focus:ring-purple-500"
                              />
                              <div>
                                <p className="font-semibold text-gray-800">{plan.name}</p>
                                <p className="text-sm text-gray-600">{plan.duration} days duration</p>
                              </div>
                            </div>
                            <div className="text-right">
                              <p className="text-xl font-bold text-purple-600">₹{plan.price}</p>
                              <p className="text-xs text-gray-500">per plan</p>
                            </div>
                          </div>
                        </label>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* Custom Price Field */}
              {selectedPlanId && (
                <div className="space-y-3">
                  <label className="flex items-center gap-2 font-semibold text-gray-800">
                    <FaRupeeSign className="text-purple-600" />
                    Custom Price
                  </label>
                  <div className="space-y-2">
                    <input
                      type="number"
                      value={customPrice}
                      onChange={(e) => setCustomPrice(e.target.value)}
                      placeholder={(() => {
                        const selectedPlan = availablePlans.find(p => p._id === selectedPlanId);
                        return selectedPlan ? `Leave empty to use original price: ₹${selectedPlan.price}` : 'Enter custom price';
                      })()}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200"
                    />
                    <p className="text-xs text-gray-500">
                      Leave empty to use the original plan price, or enter a custom price
                    </p>
                  </div>
                </div>
              )}

              {/* GST Number Field */}
              <div className="space-y-3">
                <label className="flex items-center gap-2 font-semibold text-gray-800">
                  <FiFileText className="text-purple-600" />
                  GST Number
                </label>
                <div className="space-y-2">
                  <input
                    type="text"
                    value={gstNumber}
                    onChange={(e) => setGstNumber(e.target.value.toUpperCase())}
                    placeholder="Enter GST Number"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200"
                  />
                  <p className="text-xs text-gray-500">
                    Enter GST number for billing purposes
                  </p>
                </div>
              </div>

              {/* Selected Plan Summary */}
              {selectedPlanId && (
                <div className="bg-purple-50 border border-purple-200 rounded-xl p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <FiCheckCircle className="text-purple-600" />
                    <h4 className="font-semibold text-purple-800">Selected Plan Summary</h4>
                  </div>
                  {(() => {
                    const selectedPlan = availablePlans.find(p => p._id === selectedPlanId);
                    return selectedPlan ? (
                      <div className="text-sm text-purple-700">
                        <p>{selectedPlan.name} - ₹{selectedPlan.price} for {selectedPlan.duration} days</p>
                      </div>
                    ) : null;
                  })()}
                </div>
              )}
            </div>

            {/* Modal Footer */}
            <div className="bg-gray-50 px-6 py-4 rounded-b-2xl flex gap-3 justify-end">
              <button
                onClick={() => setShowPlanModal(false)}
                className="px-6 py-2.5 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors duration-200 font-medium"
              >
                Cancel
              </button>
              <button
                onClick={assignPlan}
                disabled={!selectedPlanId || availablePlans.length === 0}
                className="px-6 py-2.5 bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-lg hover:from-purple-700 hover:to-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 font-medium shadow-lg"
              >
                Assign Plan & Generate Bill
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VendorList;
